import { Post } from "../models/Post";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./ui/alert-dialog";

interface DeletePostAlertProps {
  post: Post;
  hasPublished: boolean;
  onDelete: () => void;
  trigger: React.ReactNode;
}

export function DeletePostAlert({
  post,
  hasPublished,
  onDelete,
  trigger,
}: DeletePostAlertProps) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            {Object.values(post.connections).some(
              (connection) => connection.status === "pending"
            ) ? (
              <p>Deleting the post will cancel the scheduled post.</p>
            ) : null}
            {hasPublished && (
              <p>
                This post has already been published to connected platforms.
                Deleting it here will not remove it from those platforms.
              </p>
            )}
            <p>This operation cannot be undone.</p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-red-600 hover:bg-red-700"
            onClick={onDelete}
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
